module.exports = __webpack_public_path__ + "img/prem_before.9f48739e.jpg";